import React from 'react';

const TIcon = (props) => (
  <svg {...props} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g>
      <path d='M6.75 15H11.25' stroke={props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M3 5.25V3H15V5.25' stroke={props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M9 3V15' stroke={props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </g>
  </svg>
);

export default TIcon;
